import {Router} from '@angular/router';
import {AuthorisationService} from './services/auth/authorisation.service';
import {Routenames} from './routenames';
import {Component} from '@angular/core';
import {Features} from './services/auth/features';
import {Roles} from './services/auth/roles';

@Component({
    selector: 'app-dynamic-redirect',
    template: ''
})
export class NotDefinedRouteComponent {

    constructor(private router: Router) {
        if (AuthorisationService.hasFeature(Features.WorkordersTtmsSave)) {
            this.router.navigateByUrl(`/${Routenames.Projects}/${Routenames.Map}`);
        }
        if (AuthorisationService.hasRole(Roles.Drawer)) {
            this.router.navigateByUrl(`/${Routenames.Drawings}`);
        } else {
            this.router.navigateByUrl(`/${Routenames.WorkOrders}`);
        }
    }

}
